import React, { useEffect } from 'react';
import styles from './Box.module.css';
import { HoverState } from '../../../../assets/utils/cursorTypes';

export type BoxProps = {
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
    backgroundImage: string;
    position: string;
    company: string;
    timeline: string;
    website: string;
}

const Box = (props: BoxProps) => {

    const handleMouseEnter = () => props.setHoverElement('pointer');
    const handleMouseLeave = () => props.setHoverElement('normal');

    return (
        <a
            href={props.website}
            target='_blank'
            rel="noreferrer"
            className={styles.box}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div className={styles.backgroundContent}>
                <pre>
                    <img src={`/images/${props.backgroundImage}`} alt={`${props.company}`} />
                </pre>
            </div>
            <div className={styles.box_items}>
                <span>{props.position}</span>
                <span>{props.company}</span>
                <span>{props.timeline}</span>
            </div>
        </a>
    )
}

export default Box;
